import { Grid, Stack, CardActionArea } from '@mui/material';
import { useParams } from 'react-router-dom';

import { isValidHttpsUrl } from 'theSource/utils';
import { InternalPage, PageNotFound } from 'theSource/components';
import { mapDetailedCategory } from './utils';
import { MyCompanyCategory } from 'theSource/queries/useCompanyQuery/types';
import {
  CardStyled,
  CardMediaStyled,
  TextStyled,
} from './MyCompanyReviewPageStyled';
import { BackLink } from 'enrollment/components';

export interface MyCompanyReviewPageProps {
  data?: MyCompanyCategory[];
}

export const MyCompanyReviewPage = ({ data }: MyCompanyReviewPageProps) => {
  const { id } = useParams();

  const category = data && mapDetailedCategory(data, id ?? '');

  const handleClick = (path: string) => {
    if (isValidHttpsUrl(path!)) {
      window.open(path!, '_blank');
    }
  };

  if (!category || !category.id) {
    return <PageNotFound />;
  }

  return (
    <InternalPage
      testId="my-company-details-page"
      title={category.name}
      description={category.details}
      CustomActionComponent={<BackLink />}
      customActionAlignment="left"
    >
      <Stack spacing={6}></Stack>
      {category.myCompanyLinks && category.myCompanyLinks.length > 0 ? (
        <Grid container spacing={4} columns={2}>
          {category.myCompanyLinks.map((item, index) => (
            <Grid item xs={1} key={index}>
              <CardActionArea
                onClick={() => handleClick(item.url)}
                aria-labelledby={item.id}
              >
                <CardStyled>
                  <CardMediaStyled
                    component="img"
                    image={`https://www.google.com/s2/favicons?sz=32&domain=${item.url}`}
                    alt=""
                  />
                </CardStyled>
              </CardActionArea>
              <TextStyled variant="body2" id={item.id}>
                {item.name}
              </TextStyled>
            </Grid>
          ))}
        </Grid>
      ) : (
        <></>
      )}
    </InternalPage>
  );
};
